var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.057 13.859c-.048-.047-.255-.225-.425-.39-1.069-.971-2.819-3.504-3.353-4.83-.086-.201-.267-.71-.279-.982 0-.261.06-.51.182-.746.17-.296.437-.533.753-.663.22-.084.875-.213.887-.213.717-.13 1.883-.202 3.171-.202 1.228 0 2.346.072 3.075.178.011.012.826.142 1.105.284.51.26.827.77.827 1.315v.047c-.012.354-.33 1.1-.34 1.1-.536 1.255-2.2 3.73-3.306 4.724 0 0-.284.28-.461.401-.256.19-.571.285-.887.285-.353 0-.681-.107-.949-.308z"
  })));
}

export default SvgArrowDown;